<template>
  <div class="thisflex" style="display: flex">
    <Button type="primary" style="height: 2.25rem; margin-right: 1.875rem" @click="getaddInfo()">添加排口</Button>
    <div v-if="show">
      <div
        v-for="(item, index) in thisList"
        :key="item.id"
        :class="index + 1 < thisList.length ? 'sidebox' : ''"
        class="view-box"
      >
        <div class="view-box-top">
          <Input v-model="item.site" size="large" placeholder="请输入站点名" style="width: 180px" />

          <div v-if="yytypes == 0" class="xuanze">生产线状态</div>
          <i-switch
            v-if="yytypes == 0"
            v-model="item.switch"
            size="large"
            style="margin-right: 1.25rem"
            @on-change="change(item.switch, index)"
          >
            <span slot="open">使用</span>
            <span slot="close">未用</span>
          </i-switch>
          <div v-if="item.prostatus == 0" class="">
            <i-select
              :value="item.PRONumber"
              style="width: 200px; margin-right: 30px"
              @on-change="getProInfo($event, index)"
            >
              <i-option v-for="(items, indexs) in gkpro" :key="indexs" :value="items.pronumber">{{
                items.pronumber
              }}</i-option>
            </i-select>
          </div>
          <!-- <div v-if="item.prostatus == 0" class="">
            <i-select v-model="item.gkPro_id" style="width: 200px; margin-right: 30px">
              <i-option
                v-for="(items, indexs) in proarrList[index]"
                :key="indexs"
                :label="items.keys + '(' + items.values + ')'"
                :value="items.gk_pid"
                >{{ items.keys + '(' + items.values + ')' }}</i-option
              >
            </i-select>
          </div> -->
          <Button type="primary" style="height: 2.25rem" @click="getTJInfo(index)">确定</Button>
          <Button type="warning" style="height: 2.25rem; margin-left: 0.625rem" @click="deldata(item.gkSite_id, index)"
            >删除</Button
          >

          <!-- <Icon type="ios-add-circle-outline" class="icon" @click="addtopdiv" /> -->
        </div>
        <div id="app" class="view-box-myxuanxiang-in">
          <div class="view-box-myxuanxiang">
            <myxuanxiang :sensor-list="item" />
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="modal1" title="删除" @on-ok="ok" @on-cancel="cancel">
      <p>你确定要删除这一条数据吗？</p>
    </Modal>
  </div>
</template>

<script>
import myxuanxiang from '../components/myxuanxiang.vue';
export default {
  components: {
    myxuanxiang,
  },
  props: {
    siteList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      yytypes: '',
      value1: '',
      value2: '',
      value3: '',
      show: false,
      modal1: false,
      id: '',
      gkid: '',
      values: 0, // 标准值
      valueList: [], // 标准值列表
      switch1: true,
      myxuanxiangList: [
        {
          id: '',
          value: '',
        },
      ],
      gkpro: [],
      datastie: [],
      list: [], // 内容
      proarrList: [], // pro值的数组
      thisList: [],
    };
  },
  created() {
    this.yytypes = sessionStorage.getItem('yytype');
  },
  mounted() {
    console.log('siteList', this.siteList);
    var str = JSON.stringify(this.siteList.sitelist);
    this.thisList = JSON.parse(str);
    this.thisList.forEach((item, index) => {
      if (!item.switch) {
        if (item.prostatus === 0) {
          item.switch = true;
        } else {
          item.switch = false;
        }
      }
      this.proarrList.push([]);
      this.thisList[index].flag = true;
      if (item.PRONumber) {
        this.getProInfo(item.PRONumber, index);
      }
    });
    this.show = true;
    this.getthisPRO();
  },

  methods: {
    change(status, index) {
      if (status === true) {
        this.thisList[index].prostatus = 0;
        this.thisList[index].switch = true;
      } else {
        this.thisList[index].prostatus = 1;
        this.thisList[index].switch = false;
      }
    },
    deldata(id, index) {
      this.modal1 = true;
      this.id = id;
      this.listindex = index;
    },
    ok() {
      const api = this.ApiUrl + 'gkSite/delById';
      const data = {
        gkSite_id: this.id,
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('删除成功');
            this.thisList.splice(this.listindex, 1);
          } else {
            this.$Message.error(res.data.extend.msg || '删除失败');
          }
        },
        res => {},
      );
    },
    cancel() {
      this.modal1 = false;
    },
    getthisPRO() {
      const api = this.ApiUrl + 'gkPro/findAll';
      const params = {
        pageNo: 1,
        pageSize: 100,
      };
      this.$http.get(api, { params }).then(
        res => {
          if (res.data.extend.news === 0) {
            this.gkpro = res.data.extend.pageInfo.records;
          }
        },
        res => {},
      );
    },
    selectchange(e, index) {
      for (var i = 0; i < this.gkpro.length; i++) {
        if (this.gkpro[i].gk_pid === e) {
          this.getProInfo(this.gkpro[i].pronumber, index);
          break;
        }
      }
    },
    // 获取pro信息
    getProInfo(pronum, index) {
      this.thisList[index].PRONumber = pronum;
      for (let i = 0; i < this.gkpro.length; i++) {
        let item = this.gkpro[i];
        if (item.pronumber == pronum) {
          this.thisList[index].gkPro_id = item.gk_pid;
          break;
        }
      }
      // const api = this.ApiUrl + 'gkPro/findValues';
      // var data = {
      //   PRONumber: pronum,
      // };
      // this.$http.post(api, data).then(
      //   res => {
      //     if (res.data.extend.news === 0) {
      //       this.$set(this.proarrList, index, res.data.extend.pageInfo.records);
      //     } else {
      //       this.$Message.error('添加失败');
      //     }
      //   },
      //   res => {},
      // );
      // this.thisList[index].flag = true;
    },
    getaddInfo() {
      if (this.thisList.length !== 0) {
        // if (this.thisList[this.thisList.length - 1].pro === '' || this.thisList[this.thisList.length - 1].pro === '默认值') {
        //     this.$Message.error('请填写完成设备信息在次添加新的设备');
        //     return;
        // }
        if (
          this.thisList[this.thisList.length - 1].site === '' ||
          this.thisList[this.thisList.length - 1].site === '默认值'
        ) {
          this.$Message.error('请填写完成设备信息在次添加新的设备');
          return;
        }
        // if (this.thisList[this.thisList.length - 1].proval === '' || this.thisList[this.thisList.length - 1].proval === '默认值') {
        //     this.$Message.error('请填写完成设备信息在次添加新的设备');
        //     return;
        // }
      }
      const id = this.siteList.gkEquip_id;

      const that = this;
      const api = this.ApiUrl + 'gkSite/addGkSite';
      const data = {
        gkEquip_id: id,
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            if (that.yytypes === '0') {
              // 工况添加站点
              that.getproInfo(res.data.extend.gkSite_id);
            } else {
              // 油烟添加站点
              that.$Message.success('添加成功');
              const shebei = {};
              if (!shebei.gkEquip_id) {
                shebei.gkSite_id = res.data.extend.gkSite_id;
              }
              if (!shebei.site) {
                shebei.site = '';
              }
              if (!shebei.sensorlist) {
                shebei.sensorlist = [];
              }
              shebei.valuesid = '';
              shebei.selProid = '';
              that.thisList.push(shebei);
            }
          } else {
            this.$Message.error('添加失败');
          }
        },
        res => {},
      );
    },
    getproInfo(id) {
      const shebei = {};
      shebei.gkSite_id = id;
      shebei.pro = '';
      shebei.site = '';
      shebei.gkPro_id = '';
      shebei.prostatus = 1;
      shebei.proval = '';
      shebei.sensorlist = [];
      this.thisList.push(shebei);

      // const api = this.ApiUrl + 'gkPro/addPro';
      // const data = {
      //     gkSite_id: id,
      //     type: this.yytypes
      // };
      // this.$http.post(api, data).then(res => {
      //     if (res.data.extend.news === 0) {
      //         this.$Message.success('添加成功');
      //         const shebei = {};
      //         shebei.gkSite_id = id;
      //         shebei.pro = '';
      //         shebei.site = '';
      //         shebei.gkPro_id = '';
      //         shebei.prostatus = 1;
      //         shebei.proval = '';
      //         shebei.sensorlist = [];
      //         this.thisList.push(shebei);
      //     } else {
      //         this.$Message.error('添加失败');
      //     }
      // }, res => {

      // });
    },

    getTJInfo(index) {
      const that = this;
      for (var i = 0; i < that.thisList[index].length; i++) {
        const list = that.thisList[index];
        if (list[i].site === '' || list[i].site == null) {
          this.$Message.error('请输入站点名');
          return;
        }
      }
      const api = this.ApiUrl + 'gkSensor/updateGkSite';

      const data = {
        data: that.thisList[index],
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('修改成功');
          } else {
            this.$Message.error('修改失败');
          }
        },
        res => {},
      );
    },
  },
};
</script>

<style scoped>
.ivu-input-wrapper {
  width: 12.5rem;
  margin-right: 1.25rem;
}

.thisflex {
  flex: 9;
}

.view-box {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.625rem;
}

.sidebox {
  border-bottom: 1px dashed #ccc;
}

.view-box-top .icon {
  display: none;
  font-size: 1.875rem;
  color: #2db7f5;
}

.view-box-myxuanxiang {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  align-items: center;
}

.ivu-input {
  width: 12.5rem;
}

.xuanze {
  width: #666;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  margin-right: 1.25rem;
}

.view-box-myxuanxiang-in {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}

.view-box-top {
  width: 100%;
  display: flex;
  align-items: center;
}
</style>
